// import * as types from '../mutation-type'
import service from '@/services'
// import { storage } from '@/utils'

// getters
const getters = {

}

// actions
const actions = {
  informationAddorupdate: ({commit}, payload) => {
    return service.informationAddorupdate(commit, payload)
  },
  informationQueryInformationType: ({commit}, payload) => {
    return service.informationQueryInformationType(commit, payload)
  }
}

// mutations
const mutations = {

}

export default {
//   state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/management.js